import { Box, Typography } from "@mui/material";

import type { ChangeSection } from "components/common/ConfirmChangesDialog";
import UserAvatar from "components/common/UserAvatar";
import type {
  SecureAccessChange,
  SecureAccessPreview,
} from "features/secureUploads/secureUploads";

import { accessLine, changeHeading } from "./projectModel";

function changeRows(
  kind: "adding" | "removing",
  changes: SecureAccessChange[],
) {
  return changes.map((change) => (
    <Box
      key={change.id}
      sx={{ display: "flex", alignItems: "center", gap: 1.25 }}
    >
      <UserAvatar person={change} size={24} />
      <Box>
        <Typography variant="body2">{change.name}</Typography>
        <Typography variant="caption" color="text.secondary">
          {accessLine(kind, change)}
        </Typography>
      </Box>
    </Box>
  ));
}

/** Confirm Access Changes: who is added, then who is removed. */
export function previewSections(preview: SecureAccessPreview): ChangeSection[] {
  const sections: ChangeSection[] = [];
  if (preview.adding.length)
    sections.push({
      label: changeHeading("adding", preview.adding.length),
      tone: "success",
      rows: changeRows("adding", preview.adding),
    });
  if (preview.removing.length)
    sections.push({
      label: changeHeading("removing", preview.removing.length),
      tone: "error",
      rows: changeRows("removing", preview.removing),
    });
  return sections;
}
